module.exports = __webpack_public_path__ + "files/04e89a3b937611405ac1cf4aa862addf.png";